import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { setSelectedSuperBatch } from '@courseResume/store/coursePauseRequest';
import SuperBatchSelect from 'components/SuperBatchSelect';

function ManageStageSuperBatchSelect({ selectedSuperBatch }) {
  const dispatch = useDispatch();
  const parsedSuperBatch = selectedSuperBatch
    ? { label: selectedSuperBatch.name, value: selectedSuperBatch.id }
    : null;
  const _styles = {
    control: (styles, state) => ({
      ...styles,
      padding: '0',
    }),
  };

  const handleSelectBatch = useCallback(
    (superBatch) => {
      dispatch(
        setSelectedSuperBatch({ name: superBatch.label, id: superBatch.value })
      );
    },
    [dispatch]
  );

  return (
    <SuperBatchSelect
      styles={_styles}
      onChange={handleSelectBatch}
      value={parsedSuperBatch}
    />
  );
}

export default ManageStageSuperBatchSelect;
